import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import ProfileAndSecurity from '@views/ManageAccount/Profile/ProfileAndSecurity';

const messages = defineMessages({
  title: {
    id: 'manageAccount.profileAndSecurity',
    defaultMessage: 'Profile and Security',
  },
});

export default function ManageProfilePage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user }) => <ProfileAndSecurity user={user} />}
    </ManageAccountLayout>
  );
}
